import React from 'react';

import AppHeader from '../AppHeader';
import { IHeader } from '../AppHeader/types';

import { Container, Content, Section } from './styles';
import { Header } from '../Header/Header';
import Menu from '../Menu/Menu';
import { useLocation } from 'react-router-dom';

interface IButton {
  children?: React.ReactNode;
  headerData?: IHeader;
  showSearchInput?: boolean;
}

export const Main: React.FC<IButton> = ({ headerData, children, showSearchInput }) => {
  const monthDecember = 11;
  const currentMonth = new Date().getMonth();
  const isDecember = (month: number) => month === monthDecember;
  const isChristmas = isDecember(currentMonth);

  const { pathname } = useLocation();

  const recordingReportsPage = '/recording-reports';

  const isPageRecordingReports = pathname.includes(recordingReportsPage);

  return (
    <Container>
      <Header showSearchInput={showSearchInput} />
      {!isPageRecordingReports && <Menu />}
      <Content $noSpacingLeft={isPageRecordingReports}>
        <AppHeader isChristmas={isChristmas} {...headerData} />
        <Section>{children}</Section>
      </Content>
    </Container>
  );
};

export default Main;
